// src/components/auth/AuthCard.jsx
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card'
import DottedCorners from '@/components/DottedCorners'

const AuthCard = ({ title, description, children }) => {
  return (
    <div className="relative w-full h-full  flex items-center justify-center max-md:my-4">
      <DottedCorners position="top-right" size={120} />
      <DottedCorners position="bottom-left" size={120} />
      <Card className="border-0 shadow-none bg-transparent w-full max-w-sm max-md:my-16">
        <CardHeader className="text-center px-0">
          <CardTitle className="text-2xl">{title}</CardTitle>
          <CardDescription>{description}</CardDescription>
        </CardHeader>
        <CardContent className="px-0">
          {children}
        </CardContent>
      </Card>
    </div>
  )
}

export default AuthCard